import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
    isSelecting?: boolean;
}

export const Root = styled.div`
    margin-top:7px;
`;

export const Rectangle = styled.div`
    width: 160px;
    height: 29px;
    padding: 0px 9px 0px 13px;
    border-radius: 5px;
    border: solid 0.5px #cccccc;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    background-color: ${(props: IRootProps) => props.isSelecting ? "#122442" : ""};
    &:hover {
        background-color: ${C.GRAY}
    }
`;

export const FontName = styled.span`   
    white-space: nowrap;
    max-width: 170px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: Roboto;
    font-size: 13px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #cccccc;
    border: none;
    outline: none;
  `;

export const Arrow = styled.div`
    width: 13px;
`;
